import { View } from 'react-native';
import { ListItem } from '../../Core/List/ListItem';
import { Typography } from '../../Core/Typography/Typography';
import { cn } from '../../lib/utils';

export type PortfolioListHeaderType = {
  assetHeader: string;
  holdingsComponent?: React.ReactNode;
  holdingsHeader?: string;
  returnsHeader?: string;
  weightsHeader?: string;
  isMobile: boolean;
  className?: string;
};

export const PortfolioListHeader = ({
  assetHeader,
  holdingsComponent,
  holdingsHeader,
  returnsHeader,
  weightsHeader,
  isMobile,
  className,
}: PortfolioListHeaderType) => {
  return (
    <ListItem className={cn('p-0 bg-transparent', className)} pressable={false}>
      {isMobile ? (
        <View className="w-full flex-row justify-between">
          <View className="flex-row justify-start items-center">
            <Typography size="small" className="text-neutral-200">
              {assetHeader}
            </Typography>
          </View>
          <View className="flex items-end justify-center">
            {holdingsComponent !== undefined ? (
              holdingsComponent
            ) : (
              <Typography size="small" className="text-neutral-200">
                {holdingsHeader}
              </Typography>
            )}
          </View>
        </View>
      ) : (
        <View className="w-full flex flex-row gap-4">
          <View className="flex-row items-center justify-start gap-4 flex-[2]">
            <Typography size="small" className="text-neutral-200">
              {assetHeader}
            </Typography>
          </View>
          <View className="flex items-end justify-center flex-[2]">
            <Typography size="small" className="text-neutral-200">
              {holdingsHeader}
            </Typography>
          </View>
          <View className="flex items-end justify-center flex-1">
            <Typography size="small" className="text-neutral-200">
              {returnsHeader}
            </Typography>
          </View>
          <View className="flex items-end justify-center flex-1">
            <Typography size="small" className="text-neutral-200">
              {weightsHeader}
            </Typography>
          </View>
          <View className="flex-row items-center justify-end gap-4 flex-[3]"></View>
        </View>
      )}
    </ListItem>
  );
};
